import styled from 'styled-components';

import BackgroundBox from 'shared/components/BackgroundBox';
import { device } from 'shared/defaultTheme';

export const NotificationBackground = styled(BackgroundBox)`
  @media ${device.sm} {
    width: 96%;
    margin-left: 8px;
    .row {
      display: block;
    }
  }
  @media ${device.md} {
    width: 96%;
    margin-left: 10px;
    .row {
      display: flex;
    }
  }
  @media ${device.lg} {
    width: 97%;
    margin-left: 13px;
    .row {
      display: flex;
    }
  }
  @media ${device.xl} {
    width: 90%;
    margin-left: 0;
    .row {
      display: flex;
    }
  }
`;

export const ListSelectedDiv = styled.div`
  height: 300px;
  overflow-y: scroll;
`;
